import React from "react";
import styles from "./index.module.css";
import { Stack, Typography, TypographyProps } from "@mui/material";
import ConfigIcon from "../../../../images/portal/config.svg?react";
import { CoreRadioCard, CoreRadioCardIcon, CoreRadioCardSelectIcon } from "@verity/components/core";
import { EditQuizFooter, EditQuizFooterProps } from "@verity/components";

type ConfigHeaderProps = {
	children: React.ReactNode;
} & Omit<TypographyProps, "children">;

export function ConfigHeader({ children, ...props }: ConfigHeaderProps) {
	return (
		<div className={styles.titleWrapper}>
			<div className={styles.configIcon}>
				<ConfigIcon />
			</div>
			<Typography {...props}>{children}</Typography>
		</div>
	);
}

type CreateAssessmentTileProps = {
	selected: boolean;
	onClick: () => void;
	icon: React.ReactNode;
	title: React.ReactNode;
	description: React.ReactNode;
};

export function CreateAssessmentTile({ icon, title, description, onClick, selected }: CreateAssessmentTileProps) {
	return (
		<CoreRadioCard selected={selected} onClick={onClick} slotProps={{ button: { className: styles.assessmentTile } }}>
			<>
				<div className={styles.headerRow}>
					<CoreRadioCardSelectIcon selected={selected} />
				</div>
				<CoreRadioCardIcon enabled={selected} icon={icon} width={40} height={40} />
				<Stack spacing={0.5}>
					<Typography variant="h2" className={styles.tileText}>
						{title}
					</Typography>
					<Typography className={styles.tileDesc}>{description}</Typography>
				</Stack>
			</>
		</CoreRadioCard>
	);
}

export function CreateAssessmentFooter({ className, ...props }: EditQuizFooterProps) {
	return <EditQuizFooter {...props} className={`${styles.assessmentFooter} ${className || ""}`} />;
}
